module.exports = __webpack_public_path__ + "static/media/sqlLogo.658ce7f4.png";